var map = {
	"./icon--arrow-green.svg": 2111,
	"./icon--arrow.svg": 6713,
	"./icon--close.svg": 8222,
	"./icon--email.svg": 910,
	"./icon--facebook.svg": 6,
	"./icon--link.svg": 1162,
	"./icon--linkedin.svg": 6852,
	"./icon--mouse.svg": 8039,
	"./icon--office-phone.svg": 8537,
	"./icon--office.svg": 7266,
	"./icon--phone.svg": 9666,
	"./icon--sandwich.svg": 2797,
	"./icon--twitter.svg": 3811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3394;